<template>
  <!-- 新增v-if="open"為了讓他重啟時刷新狀態 -->
  <div class="modal fade confirm" :class="{ 'is-open': open }">
    <!------------------------ 步驟一start ---------------------------->
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">發送EMAIL</h3>
        </div>
        <div class="modal-body px_37">
          <!-- -------------------主要區塊start ----------------------->
          <section class="editServiceForm search pt_0">
            <label class="editServiceForm__inputItem mb_10">
              <span>收件人</span>
              <input
                type="text"
                class="form-control form-control-inline mr_5"
                style="width: 280px"
                v-model.trim="mailForm.TO"
                data-vv-name="mail_to"
                v-validate="'required|email'"
                :class="{ 'is-invalid': errors.has(`mail_to`) }"
                placeholder="僅能輸入一組Email"
              />
              <span class="editServiceForm__inputItem--error">
                {{ errors.first(`mail_to`) ? "MAIL格式有誤" : "必填" }}
              </span>
            </label>
            <label class="editServiceForm__inputItem mb_10">
              <span>寄件人</span>
              <input
                type="text"
                class="form-control form-control-inline mr_3"
                style="width: 120px"
                v-model="mailForm.FROM"
                maxlength="20"
                data-vv-name="mail_from"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has(`mail_from`) }"
                placeholder="帳戶名稱"
                @input="checkFrom"
              />
              <div class="mr_8">{{ mailDomain }}</div>
              <span class="editServiceForm__inputItem--error">
                {{ errors.first(`mail_from`) ? "帳戶不得為空" : "必填" }}
              </span>
            </label>
            <label class="editServiceForm__inputItem mb_10">
              <span>副本收件人</span>
              <input
                type="text"
                class="form-control form-control-inline mr_5"
                style="width: 280px"
                v-model.trim="mailForm.CC"
                data-vv-name="mail_cc"
                v-validate="'email'"
                :class="{ 'is-invalid': errors.has(`mail_cc`) }"
                placeholder="僅能輸入一組Email"
              />
              <span class="editServiceForm__inputItem--error">
                {{ errors.first(`mail_cc`) ? "MAIL格式有誤" : "" }}
              </span>
            </label>
            <label class="editServiceForm__inputItem mb_10">
              <span>主旨</span>
              <input
                maxlength="26"
                type="text"
                class="form-control form-control-inline"
                style="width: 280px"
                v-model.trim="mailForm.Title"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has(`mail_title`) }"
              />
            </label>
            <div class="action text-right mt_10">
              <button
                type="submit"
                class="btn btn-default btn-sm py_5"
                @click="$emit('close')"
              >
                取消
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-sm py_5 ml_10"
                @click="toSend()"
              >
                發送
              </button>
            </div>
          </section>
          <!-- -------------------主要區塊end ----------------------->
        </div>
      </div>
    </div>
    <!------------------------ 步驟一end ---------------------------->
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import mf_Mixin from "@/desktop/views/mf/mixin";
import _ from "lodash";

export default {
  name: "SendEmailPopup",
  mixins: [mf_Mixin],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    serviceInfo: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      mailForm: {
        FROM: "",
        TO: "",
        CC: "",
        Title: "保險規劃建議書",
      },
      mailDomain: "@cathaylife.com.tw",
    };
  },
  computed: {},
  mounted() {
    if (this.$store.getters.IsBankUser) {
      this.mailDomain = "@cathaybk.com.tw";
    }
  },
  methods: {
    async toSend() {
      const checkResult = await this.$validator.validateAll();
      if (checkResult) {
        this.$emit("send", this.mailForm);
      }
    },
    checkFrom: function() {
      this.mailForm.FROM = this.mailForm.FROM.replace(/[@\s]/g, '');
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.mailForm = {
          TO: "",
          CC: "",
          FROM: "",
          Title: "保險規劃建議書",
        };
        this.$validator.reset();
      }
    },
  },
};
</script>

<style lang="scss">
.editServiceForm {
  display: flex;
  flex-direction: column;
  &__inputItem {
    display: flex;
    align-items: center;
    strong {
      display: inline-block;
      width: 20px;
      text-align: center;
    }
    & > span {
      display: inline-block;
      width: 84px;
      font-weight: 700;
    }
    &--error {
      font-size: 13px;
      line-height: 1.69;
      color: #de4054;
      white-space: nowrap;
    }
  }
}
</style>
